import React from "react"
import { Link, graphql } from "gatsby"

import analytics from '../analytics/analytics';
import Layout from "../components/layout"
import SEO from "../components/seo"
import { rhythm, scale } from "../utils/typography"

import Image from 'gatsby-image';

require("typeface-roboto");

if (typeof window !== 'undefined') {
  analytics.page(window.location.pathname, {
    search: window.location.search,
    hash: window.location.hash
  });
}


class BlogIndex extends React.Component {
  render() {
    const { data } = this.props;
    const posts = data.allMarkdownRemark.edges;
    const description = data.site.siteMetadata.description;

    return (
      <Layout location={this.props.location}>
        <SEO pageTitle="Belajar Bahasa Inggris itu mudah" />
        <header
          style={{
            fontFamily: "Roboto",
            fontWeight: 700,
            lineHeight: 1.2,
            ...scale(1.3),
            margin: `${rhythm(5)} ${rhythm(1)} ${rhythm(3.5)}`,
          }}
        >
          {description}
        </header>
        {posts.map(({ node }) => {
          const title = node.frontmatter.title || node.fields.slug;
          return (
            <article
                style={{
                  borderRadius: rhythm(1 / 4),
                  boxShadow: `#ccc 0 ${rhythm(3/4)} ${rhythm(1)} ${rhythm(1 / 4)}`,
                  marginBottom: rhythm(2),
                  overflow: "hidden",
                }}
                key={node.fields.slug}>
              <Link style={{ boxShadow: `none`, color: "unset" }} to={node.fields.slug}>
                <header>
                  <div style={{
                    maxHeight: "200px",
                    overflow: "hidden",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "stretch"
                  }}>
                    <Image fluid={node.frontmatter.hero.childImageSharp.fluid}/>
                  </div>
                  <h4
                    style={{
                      marginBottom: rhythm(1 / 4),
                      marginTop: rhythm(5 / 4),
                      padding: `0 ${rhythm(3 / 4)}`,
                      lineHeight: 1.4
                    }}
                  >
                      {title}
                  </h4>
                </header>
                <section
                  style={{
                    fontFamily: "Roboto",
                    padding: `0 ${rhythm(3 / 4)}`,
                    ...scale(-0.5),
                    lineHeight: 1.4
                  }}
                >
                  <div
                    style={{
                      color: "#888"
                    }}
                    dangerouslySetInnerHTML={{
                      __html: node.frontmatter.description || node.excerpt,
                    }}
                  />
                  <div
                    style={{
                      fontWeight: 800,
                      fontSize: "80%",
                      margin: `${rhythm(1)} 0`
                    }}
                  >
                    {node.frontmatter.author}
                  </div>
                </section>
              </Link>
            </article>
          )
        })}
      </Layout>
    )
  }
}

export default BlogIndex

export const pageQuery = graphql`
  query {
    site {
      siteMetadata {
        title
        description
      }
    }
    allMarkdownRemark(sort: { fields: [frontmatter___date], order: DESC }) {
      edges {
        node {
          excerpt
          fields {
            slug
          }
          frontmatter {
            date(formatString: "MMMM DD, YYYY")
            title
            description
            author
            hero {
              childImageSharp {
                fluid(maxWidth: 800) {
                  ...GatsbyImageSharpFluid
                }
              }
            }
          }
        }
      }
    }
  }
`;
